export enum FazzBizApiPaths {
  Wallets = 'dashboard/wallets/',
  MorakLoanVerificationStatus = 'dashboard/loans/verification/status',
}
